import { JSConn } from "@/utilities/js-conn";
import { GrindingLoadBaleYardLotLineItem } from "../grindingLoadBaleYardLotLineItem";
import { GrindingLoadLineItem } from "../grindingLoadLineItems";

export interface GrindingLoad {
  id: string;
  name: string;
  client: string;
  client_id: string;
  date: string;
  total_tons: number;
  grinding_load_bale_yard_lot_line_items: GrindingLoadBaleYardLotLineItem[];
  grinding_load_line_items: GrindingLoadLineItem[];
}

interface GrindingLoadState {
  grindingLoads: GrindingLoad[];
  grindingLoad: GrindingLoad | {};
}

const itemDetails = {
  pluralName: "grindingLoads",
  singularName: "grindingLoad",
};

const state: GrindingLoadState = {
  grindingLoads: [],
  grindingLoad: {},
};

const mutations = {
  LOAD_GRINDING_LOADS(state: GrindingLoadState, payload: GrindingLoad[]) {
    state.grindingLoads = payload;
  },
  LOAD_GRINDING_LOAD(state: GrindingLoadState, payload: GrindingLoad) {
    state.grindingLoad = payload;
  },
};

const actions = {
  needGrindingLoads(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return new Promise((resolve, _reject) => {
      const grindingLoads: GrindingLoad[] = [
        {
          id: "3447c94f-e651-496e-9833-fdbcfd555048",
          name: "This description",
          client: "Grinding Load Client",
          client_id: "07d3895d-467c-451e-9278-d6e2c0eb7481",
          date: "2020-01-23",
          total_tons: 22.6,
          grinding_load_bale_yard_lot_line_items: [],
          grinding_load_line_items: [],
        },
        {
          id: "2529497b-24f5-4fbf-b7ed-64ffe487c782",
          name: "Another load",
          client: "Grinding Load Client",
          client_id: "07d3895d-467c-451e-9278-d6e2c0eb7481",
          date: "2020-01-23",
          total_tons: 24.6,
          grinding_load_bale_yard_lot_line_items: [],
          grinding_load_line_items: [],
        },
      ];
      context.commit("LOAD_GRINDING_LOADS", grindingLoads);
      resolve(jsConn);
    });
  },
};

const getters = {
  grindingLoadsForTable: (state: GrindingLoadState) => {
    return state.grindingLoads;
  },
};

const grindingLoadsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default grindingLoadsModule;
